import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';

import * as yup from 'yup';
import { validate } from 'uuid';

/** Common validation schema for UUIDs (any version) */
export const uuidSchema = yup
  .string()
  .test({
    name: 'uuid-schema',
    message: DtoMessageEnum.INVALID_UUID,
    test: (value, context) => {
      if (!value) {
        return context.schema?.spec?.optional || context.schema?.spec?.nullable;
      }

      return validate(value);
    },
  });
